import React, { HTMLAttributes } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'

const jss = (theme) => {
    const { colors } = theme['foundations-library'] || {}

    return {
        content: {
            margin: '0 auto',
            border: `1px solid ${colors.neutral[100]}`,
            padding: '20px',
            borderRadius: '10px'
        }
    }
}

const useStyles = makeStyles(jss)

type PropsInterface = HTMLAttributes<HTMLDivElement>

/**
 *
 */
const OutlinedContent = ({ children, className, ...props }: PropsInterface): JSX.Element => {
    const styles = useStyles()
    return <div {...props} className={clsx(styles.content, className)}>{children}</div>
}

export default OutlinedContent
